import { render } from "./analytics-dashboard.vue?vue&type=template&id=d8c8e83a"
import script from "./analytics-dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./analytics-dashboard.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./analytics-dashboard.vue?vue&type=style&index=0&id=d8c8e83a&module=true&lang=css"
cssModules["$style"] = style0
if (module.hot) {
  module.hot.accept("./analytics-dashboard.vue?vue&type=style&index=0&id=d8c8e83a&module=true&lang=css", () => {
    cssModules["$style"] = style0
    __VUE_HMR_RUNTIME__.rerender("d8c8e83a")
  })
}

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__file',"resources/js/vueComponents/admin/analytics/analytics-dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d8c8e83a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d8c8e83a', __exports__)) {
    api.reload('d8c8e83a', __exports__)
  }
  
  module.hot.accept("./analytics-dashboard.vue?vue&type=template&id=d8c8e83a", () => {
    api.rerender('d8c8e83a', render)
  })

}


export default __exports__